import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

const RedirectLoginUserType = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userType = searchParams.get('userType');

  useEffect(() => {
    const validUserTypes = ['partner', 'investor', 'portfolio'];

    if (userType && !validUserTypes.includes(userType)) {
      void navigate('/fr/authentication/', { replace: true });
    }
  }, [userType, navigate]);

  return null;
};

export default RedirectLoginUserType;
